export default function enumValues<T>(enumObject: T): Array<(typeof enumObject)[keyof T]> {
  return Object.values(enumObject);
}
